module.exports = __webpack_public_path__ + "static/media/Web-Optimize-PDF.496f0c1e.png";